import { ColorEnum } from '@/constants/color'
import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import { DeliveryTime } from '@/features/orders/types/app'
import Typography from '@/features/ui/typography'
import { useIntervaledState } from '@/hooks/useIntervalState'
import { getCountdown } from '@/utils/getCountdown'
import { FC, ReactNode, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface OrderStateAndCountdownProps {
    deliveryTime: DeliveryTime
    deliveryTypeCategory: DeliveryTypeCategory
    State?: ReactNode
}

const OrderStateAndCountdown: FC<OrderStateAndCountdownProps> = ({
    deliveryTime,
    deliveryTypeCategory,
    State,
}) => {
    const { t } = useTranslation()

    const [countdown, isDelayed] = useIntervaledState(
        useCallback(() => getCountdown(deliveryTime), [deliveryTime]),
        60000
    )

    const color = !isDelayed ? ColorEnum.EMERALD_700 : ColorEnum.BRICK_500

    return (
        <View style={styles.container}>
            {State}
            <View style={styles.countdownContainer}>
                <Typography.Description size="large" font="bold" style={{ color }}>
                    {countdown}
                </Typography.Description>
                <Typography.Description size="small" font="medium" style={{ color }}>
                    {!isDelayed
                        ? t(`order.countdown.deliveryTypeCategory.${deliveryTypeCategory}`)
                        : t('order.countdown.delayed')}
                </Typography.Description>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignSelf: 'stretch',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 12,
    },
    countdownContainer: {
        alignItems: 'flex-end',
    },
})

export default OrderStateAndCountdown
